import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import { SortingColumn } from '@tanstack/react-table'

export const SortArrow = <T,>(
  isSorted: ReturnType<SortingColumn<T>['getIsSorted']>,
): React.JSX.Element => {
  switch (isSorted) {
    case 'asc': {
      return <ArrowDropUp data-cy='arrow-drop-up-icon' />
    }
    case 'desc': {
      return <ArrowDropDown data-cy='arrow-drop-down-icon' />
    }
    default: {
      return <></>
    }
  }
}
